import { theme } from "../theme";

export const getMonitorEventTitles = (monitorType: string) => {
  switch (monitorType) {
    case "INVOICE_EARLY_PAYMENT":
      return "aml.earlyPayments";
    case "INTERNALLY_INVOICED_TRANSACTION":
      return "aml.internalInvoiceTransactions";
    case "ISSUER_ON_BLACKLIST_DETECTED":
      return "aml.issuerBlacklisted";
    case "ISSUER_COMPANY_NAME_CHANGED":
      return "aml.companyNameChange";
    case "ISSUER_FRAUD_INDICATOR_DETECTED":
      return "aml.fraudIndicated";
    case "ISSUER_INDUSTRY_CODE_CHANGED":
      return "aml.industryCodeChange";
    case "ISSUER_KYC_OUTDATED":
      return "aml.kycOutdated";
    case "RECIPIENT_ON_BLACKLIST":
      return "aml.recipientBlacklisted";
    case "AGREEMENT_SIGNED_FROM_RISK_COUNTRY":
      return "aml.agreementSignedFromHighRiskCountry";
    case "AGREEMENT_SIGNED_WITH_ANONYMIZED_IP":
      return "aml.agreementSignedWithAnonymizedIp";
    case "MULTIPLE_ENGAGEMENTS":
      return "aml.multipleEngagements";
    case "ISSUER_BOARD_MEMBER_CHANGED":
      return "aml.issuerBoardMemberChanged";
    case "INVOICE_EXTENDED_PAYMENT_TERMS_DETECTED":
      return "aml.invoiceExtendedPaymentTerms";
    case "EXPECTED_INVOICE_VOLUME_EXCEEDED":
      return "aml.expectedInvoiceVolumeExceeded";
    case "ISSUER_AUDITOR_UPDATED":
      return "aml.issuerAuditorChanged";
    case "SANCTION_LIST_HIT":
      return "aml.sanctionHitList";
    case "ISSUER_BENEFICIAL_OWNERSHIP_CHANGED":
      return "aml.issuerBeneficialOwnerChanged";

    default:
      return monitorType;
  }
};

export const MonitorTypes = [
  { value: "IssuerOnBlacklistDetected", label: "aml.issuerBlacklisted" },
  { value: "RecipientOnBlacklist", label: "aml.recipientBlacklisted" },
  {
    value: "InternallyInvoicedTransaction",
    label: "aml.internalInvoiceTransactions",
  },
  { value: "InvoiceEarlyPayment", label: "aml.earlyPayments" },
  { value: "IssuerCompanyNameChanged", label: "aml.companyNameChange" },
  { value: "IssuerFraudIndicatorDetected", label: "aml.fraudIndicated" },
  { value: "IssuerIndustryCodeChanged", label: "aml.industryCodeChange" },
  { value: "IssuerKycOutdated", label: "aml.kycOutdated" },
  {
    value: "AgreementSignedFromRiskCountry",
    label: "aml.agreementSignedFromHighRiskCountry",
  },
  {
    value: "AgreementSignedWithAnonymizedIp",
    label: "aml.agreementSignedWithAnonymizedIp",
  },
  {
    value: "IssuerBeneficialOwnershipChanged",
    label: "aml.issuerBeneficialOwnerChanged",
  },
  {
    value: "InvoiceExtendedPaymentTermsDetected",
    label: "aml.invoiceExtendedPaymentTerms",
  },
  {
    value: "IssuerBoardMemberChanged",
    label: "aml.issuerBoardMemberChanged",
  },
  { value: "MultipleEngagements", label: "aml.multipleEngagements" },
  {
    value: "ExpectedInvoiceVolumeExceeded",
    label: "aml.expectedInvoiceVolumeExceeded",
  },
  {
    value: "IssuerAuditorUpdated",
    label: "aml.issuerAuditorChanged",
  },
  { value: "SanctionListHit", label: "aml.sanctionHitList" },
];

export const getRiskScoreTitleAndDescription = (riskScoreType: string) => {
  switch (riskScoreType) {
    case "RULE_NEW_CUSTOMER_MARKING":
      return {
        title: "aml.riskScoreTitles.RULE_NEW_CUSTOMER_MARKING",
        description: "aml.riskScoreTitles.ruleNewCustomerMarkingDescription",
      };
    case "RULE_CASH_INTENSIVE_BUSINESS":
      return {
        title: "aml.riskScoreTitles.RULE_CASH_INTENSIVE_BUSINESS",
        description: "aml.riskScoreTitles.ruleCashIntensiveBusinessDescription",
      };
    case "RULE_COMPLEX_OWNERSHIP_STRUCTURE":
      return {
        title: "aml.riskScoreTitles.RULE_COMPLEX_OWNERSHIP_STRUCTURE",
        description:
          "aml.riskScoreTitles.ruleComplexOwnershipStructureDescription",
      };
    case "RULE_CUSTOMER_FIPO_MARKING":
      return {
        title: "aml.riskScoreTitles.RULE_CUSTOMER_FIPO_MARKING",
        description: "aml.riskScoreTitles.ruleCustomerFipoMarkingDescription",
      };
    case "RULE_COUNTRY_RELATIONS":
      return {
        title: "aml.riskScoreTitles.RULE_COUNTRY_RELATIONS",
        description: "aml.riskScoreTitles.ruleCountryRelationsDescription",
      };
    case "RULE_HIGH_RISK_INDUSTRY":
      return {
        title: "aml.riskScoreTitles.RULE_HIGH_RISK_INDUSTRY",
        description: "aml.riskScoreTitles.ruleHighRiskIndustryDescription",
      };
    case "RULE_HISTORICAL_BANKRUPTCIES_CORPORATE_REPRESENTATIVES":
      return {
        title:
          "aml.riskScoreTitles.RULE_HISTORICAL_BANKRUPTCIES_CORPORATE_REPRESENTATIVES",
        description: "aml.riskScoreTitles.ruleBankruptciesDescription",
      };
    case "RULE_ON_SITE_MEETING_OCCURED":
      return {
        title: "aml.riskScoreTitles.RULE_ON_SITE_MEETING_OCCURED",
        description: "aml.riskScoreTitles.ruleOnSiteMeetingOccuredDescription",
      };
    case "RULE_POLITICALLY_EXPOSED_PERSONS":
      return {
        title: "aml.riskScoreTitles.RULE_POLITICALLY_EXPOSED_PERSONS",
        description:
          "aml.riskScoreTitles.rulePoliticallyExposedPersonDesccription",
      };
    case "RULE_DEBT_BALANCE":
      return {
        title: "aml.riskScoreTitles.RULE_DEBT_BALANCE",
        description: "aml.riskScoreTitles.ruleDebtBalanceDescription",
      };
    case "RULE_INTERNAL_KYC_CUSTOMER_SERVICES":
      return {
        title: "aml.riskScoreTitles.RULE_INTERNAL_KYC_CUSTOMER_SERVICES",
        description: "aml.riskScoreTitles.ruleFgServicesDescription",
      };
    case "RULE_NON_TRIVIAL_EXPOSURE_INDUSTRY_CODE_RISK":
      return {
        title:
          "aml.riskScoreTitles.RULE_NON_TRIVIAL_EXPOSURE_INDUSTRY_CODE_RISK",
        description:
          "aml.riskScoreTitles.ruleNonTrivialExposureIndustryCodeRisk",
      };
    case "RULE_VERIFIERA_COMPANY_REPRESENTATIVES":
      return {
        title: "aml.riskScoreTitles.RULE_VERIFIERA_COMPANY_REPRESENTATIVES",
        description: "aml.riskScoreTitles.ruleVerifieraCompanyRepresentatives",
      };
    default:
      return { title: riskScoreType, description: "-" };
  }
};

export const getRiskLevel = (totalScore: number) => {
  return totalScore < 2 ? "Normal" : totalScore < 5 ? "Förhöjd" : "Högrisk";
};
export const getRiskLevelColor = (
  totalScore: number,
  manualRiskScore?: any
) => {
  return manualRiskScore !== undefined
    ? theme.colors.info
    : totalScore < 2
    ? theme.colors.success
    : totalScore < 5
    ? theme.colors.warning
    : theme.colors.error;
};
